import { useFetchWrapper } from 'helpers';
import { Visualization } from 'states';
import { APIS } from '../constants';
import { PreviewRequest, PreviewResponse } from 'helpers/kpiBuilder/previewRequest';

// A failed save comes back as HTTP 200 with `statusInfo` instead of the saved list.
export type VisualizationSaveResponse = Visualization[] & { statusInfo?: { errorMessage?: string } };

const useVisualizationService = () => {
  const baseUrl = `${process.env.REACT_APP_BASE_API_URL}`;
  const fetchWrapper = useFetchWrapper();

  const createOrUpdateVisualization = (visualization: Visualization) => {
    return fetchWrapper.post<VisualizationSaveResponse>(
      new URL(`${baseUrl}${APIS.VISUALIZATION.ADD_UPDATE_VISUALIZATION}`),
      visualization
    );
  };

  const getAllVisualizations = () => {
    return fetchWrapper.get<Visualization[]>(new URL(`${baseUrl}${APIS.VISUALIZATION.GET_ALL_VISUALIZATION}`));
  };

  const getVisualization = (visualizationCode: string) => {
    return fetchWrapper.get<Visualization[]>(
      new URL(`${baseUrl}${APIS.VISUALIZATION.GET_VISUALIZATION}${visualizationCode}`)
    );
  };

  // Runs an unsaved visualization against the real data. Admins only; anyone else gets a 403.
  const previewVisualization = (request: PreviewRequest) => {
    return fetchWrapper.post<PreviewResponse>(new URL(`${baseUrl}${APIS.VISUALIZATION.PREVIEW_CHART}`), request);
  };

  return {
    createOrUpdateVisualization,
    getAllVisualizations,
    getVisualization,
    previewVisualization,
  };
};

export { useVisualizationService };
